
import {JWT} from "../jwt";
import * as auth0Api from "../auth0Api";

/**
 * Wraps around Auth0 IdToken, but its a access token for our service apis
 * @type {Function}
 */
export class AccessToken extends JWT {

    private _clientId: string;

    constructor(clientId, private tokenObj) {
        super(tokenObj.id_token);
        this._clientId = clientId;
    }

    static fromAuthorizationHeader(authHeader) {
        if (authHeader === undefined || authHeader === null) {
            authHeader = "";
        }
        var components = authHeader.split(" ");
        if (components.length !== 2) {
            return null;
        }

        var type = components[0];
        var token = components[1];

        var decodedJwt = (new JWT(token)).decode();
        var clientId = (<any>decodedJwt).aud;

        return new AccessToken(clientId, {
            token_type: type,
            id_token: token
        });
    }

    /**
     * Generate a new access token - auth0 style!
     * @param payload
     * @param options
     * @param secret
     * @returns {AccessToken}
     */
    fromPayloadOptionsAndSecret(payload, options, secret) {
        var jwtToken = JWT.fromPayloadOptionsAndSecret(payload, options, secret);

        return new AccessToken(options.audience || payload.aud, {
            token_type: "Bearer",
            id_token: jwtToken.token()
        });
    };


    /**
     * Gets the internal tokenObj struct which can be used to later reconstrict this object
     */
    getTokenObject() {
        return this.tokenObj;
    };


    /**
     * Returns the type of token, e.g. "Bearer"
     * @returns {token_type}
     */
    type() {
        return this.tokenObj.token_type;
    };


    /**
     * Returns a string which can be used in as a value in the authorization header
     * @returns {string}
     */
    authorizationString() {
        return this.type() + " " + this.token();
    };

    /**
     * Returns the client id to which this token belongs.
     * @returns {String}
     */
    clientId() {
        return this._clientId;
    };

    getInfo(callback) {
        auth0Api.tokenInfo(this.token(), callback);
    };

    getAppToken(dstClientId, apiType, callback) {
        var This = this;
        auth0Api.delegate_withIdToken(This.token(), {
            srcClientId: This.clientId(),
            dstClientId: dstClientId,
            apiType: apiType
        }, function (err, tokenObj) {
            if (err) {
                return setImmediate(callback.bind(null, err));
            }
            return setImmediate(callback.bind(null, null, new AccessToken(dstClientId, tokenObj)));
        });
    };
}


/**
 * Wraps around Auth0 RefreshToken
 * @type {Function}
 */
export class RefreshToken {
    constructor(private refreshToken) {

    }


    /**
     * Converts the refreshToken object into a idToken object
     * @param srcClientId
     * @param dstClientId
     * @param callback(err, auth0IdToken)
     * @returns {*}
     */
    generateIdToken(srcClientId, dstClientId, callback) {
        return auth0Api.delegate_withRefreshToken(this.refreshToken, {
            srcClientId: srcClientId,
            dstClientId: dstClientId
        }, function (err, token) {
            if (err) {
                return setImmediate(callback.bind(null, err));
            }
            return setImmediate(callback.bind(null, null, new AccessToken(dstClientId, token)));
        });
    };

    /**
     * Gets the refresh token string
     * @returns {*}
     */
    token() {
        return this.refreshToken;
    };

}
